<template>
  <section class="w-1/5 max-w-[230px] bg-white border-r border-gray-200 flex-shrink-0 overflow-y-auto shadow-sm hidden sm:block">
    <div class="flex flex-col h-full">
      <!-- Modern Header with gradient accent -->
      <div
        v-if="showTitle"
        class="px-6 py-5 border-b border-gray-200 bg-gradient-to-br from-white to-gray-50"
      >
        <h2 class="font-semibold text-base text-gray-900 tracking-tight">
          <slot name="title" />
        </h2>
      </div>

      <!-- Main Navigation -->
      <div class="flex-1 py-3">
        <slot name="content" />
      </div>

      <!-- Additional Section -->
      <div class="border-t border-gray-200 bg-gray-50/50">
        <slot name="additional" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const showTitle = defineModel<boolean>('showTitle', { required: true,
  default: true,
})
</script>
